import { useEffect, useState } from "react";
import Select from "react-select";
import { fetchWarehouseLists } from "../../services/warehouses";

function WarehouseSelect(props) {
  const { inputName, onChangeWarehouseOption, selectedValues, isMultiple } =
    props;
  const [warehouseOptions, setWarehouseOptions] = useState([]);
  const [selectedOptions, setSelectedOptions] = useState([]);
  useEffect(() => {
    const _fetchWarehouseLists = async () => {
      await fetchWarehouseLists()
        .then((response) => {
          const { data } = response;
          if (data.data.warehouses) {
            const _options = [];
            const _selectedOptions = [];
            data.data.warehouses.forEach((v) => {
              _options.push({
                value: v["id"],
                label: v["name"],
              });
              if (selectedValues.includes(v["id"])) {
                _selectedOptions.push({
                  value: v["id"],
                  label: v["name"],
                });
              }
            });
            setWarehouseOptions(_options);
            if (_selectedOptions.length) {
              setSelectedOptions(_selectedOptions);
            }
          }
        })
        .catch((err) => {
          console.log(err.response.data);
        });
    };
    _fetchWarehouseLists();
  }, []);
  return (
    <Select
      isMulti={isMultiple}
      name={inputName}
      options={warehouseOptions}
      value={selectedOptions}
      onChange={(e) => {
        if (selectedOptions) {
          setSelectedOptions(e);
        }
        if (onChangeWarehouseOption) {
          const _selectedOptions = [];
          e.forEach((v) => {
            _selectedOptions.push(v["value"]);
          });
          onChangeWarehouseOption(_selectedOptions);
        }
      }}
    />
  );
}

WarehouseSelect.defaultProps = {
  inputName: "warehouse_id",
  onChangeWarehouseOption: null,
  selectedValues: [],
  isMultiple: false,
};

export default WarehouseSelect;
